var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "h-10 w-10 rounded-full flex justify-center items-center bg-chip-100",
    },
    [
      _vm._t("default", function () {
        return [
          _vm.text
            ? _c("p", { staticClass: "text-sm capitalize" }, [
                _vm._v(_vm._s(_vm.text)),
              ])
            : _vm._e(),
          _vm.avatar
            ? _c("S3Image", {
                staticClass:
                  "inline-block h-10 w-10 rounded-full object-cover object-center",
                attrs: { s3FileKey: _vm.avatar },
              })
            : _vm._e(),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }